<template>
  <div class="app-container">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="首字母：">
          <el-input v-model.trim="queryForm.initial" clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model.trim="queryForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="content">
        <el-table :data="tableData" ref="table" style="width: 100%">
          <el-table-column prop="id" label="编号" key="id"> </el-table-column>
          <el-table-column prop="image" label="LOGO">
            <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.image"
                alt
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="品牌" key="name" />
          <el-table-column width="150" key="todo" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="bj(scope.$index, scope.row)" size="small"
                >编辑</el-button
              >
              <el-button @click="sc(scope.$index, scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改"
      :visible.sync="editData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="editClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="LOGO：" required>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="品牌：" prop="name">
          <el-input v-model.trim="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="首字母(A-Z)：" prop="initial">
          <el-input v-model.trim="editForm.initial"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="editUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="LOGO：" required>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="品牌：" prop="name">
          <el-input v-model.trim="newForm.name"></el-input>
        </el-form-item>
        <el-form-item label="首字母(A-Z)：" prop="initial">
          <el-input v-model.trim="newForm.initial"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { carBrand } from "../axios/api";
export default {
  data() {
    return {
      imagesWF: [],
      queryForm: {
        name: "",
        initial: "",
      },
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      editData: false,
      editForm: {
        name: "",
        initial: "",
      },
      newData: false,
      newForm: {
        name: "",
        initial: "",
      },
      rules: {
        name: [{ required: true, message: "请输入品牌", trigger: "blur" }],
        initial: [{ required: true, message: "请输入首字母", trigger: "blur" }],
      },
      tableData: [],
      limit: 1, //限制文件数量
    };
  },
  methods: {
    // 上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      carBrand
        .upload(formData)
        .then(function (res) {
          console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function (res) {});
    },
    // 上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },

    search() {
      this.currentPage = 1;
      this.init();
    },
    reset() {
      this.queryForm.name = "";
      this.queryForm.initial = "";
      this.currentPage = 1;
      this.init();
    },
    add() {
      this.newData = true;
    },
    newClose() {
      this.$refs["newForm"].resetFields();
      this.newData = false;
      this.imagesWF = [];
    },
    newCancel() {
      this.$refs["newForm"].resetFields();
      this.newData = false;
      this.imagesWF = [];
    },
    newUpdate() {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });

          let data = {
            name: that.newForm.name,
            initial: that.newForm.initial,
            image: newImages.toString(),
          };

          if (data.image == "") {
            this.$message.warning("请上传品牌照片!");
            return;
          }
          // console.log(data)
          // return
          carBrand
            .addTable(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("添加成功!");
                that.disabled = false;
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.imagesWF = [];
                // that.currentPage = 1
                that.init();
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },
    current_change(currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    bj(index, row) {
      // console.log(row)
      var that = this;
      this.editData = true; //显示弹框

      this.editForm = row; // editForm是Dialog弹框的data

      let newData = [];
      let newImage = {};
      newImage.url = row.image;
      newData.push(newImage);

      // console.log(newData)
      this.imagesWF = newData;
    },
    editClose() {
      this.imagesWF = [];
      this.$refs["editForm"].clearValidate();
      this.editForm = {};
      this.editData = false;
    },
    editCancel() {
      this.imagesWF = [];
      this.$refs["editForm"].clearValidate();
      this.editForm = {};
      this.editData = false;
    },
    editUpdate() {
      var that = this;
      that.$refs["editForm"].validate((valid) => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });
          var data = {
            name: that.editForm.name,
            initial: that.editForm.initial,
            image: newImages.toString(),
          };
          carBrand
            .editTable(data, that.editForm.id)
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("更新成功!");
                that.editData = false;
                that.$refs["editForm"].resetFields();
                that.imagesWF = [];
                // that.currentPage = 1
                that.init();
              }
            })
            .catch(function (res) {
              that.editData = false;
              that.$refs["editForm"].resetFields();
              // console.log(res)
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },
    sc(index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          carBrand
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (error) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "已取消删除",
            type: "info",
            duration: 2000,
          });
        });
    },
    init() {
      var that = this;
      that.loading = true;
      //获取品牌列表
      var data = {
        name: that.queryForm.name ? that.queryForm.name : undefined,
        initial: that.queryForm.initial ? that.queryForm.initial : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };

      carBrand
        .getTable(data)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)
            const { list, totalNumber } = res.data;
            // list.map((lis)=>{
            //   lis.createdAt = moment(new Date(lis.createdAt * 1000)).format("YYYY-MM-DD")
            // })
            that.total = totalNumber;
            that.tableData = list;
            // // 根据品牌查询
            // that.MakeList = list
          }
        })
        .catch(function (error) {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/CarBrand.vue